import {
  buildDeveloperDetail,
  buildUserFacingHttpMessage,
} from "./verboseHttpError";

function safeDispatch(detail) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new CustomEvent("wcp:error", { detail }));
}

export function dispatchHttpError({
  status,
  message,
  data,
  url,
  method,
  stack,
} = {}) {
  const userMessage = buildUserFacingHttpMessage({ status, message, data, url, method });
  const developerDetail = buildDeveloperDetail({ status, message, data, url, method });

  safeDispatch({
    error: {
      kind: "HTTP_ERROR",
      status,
      message: userMessage,
      developerDetail,
      data,
      issues: null,
      raw: data,
      url,
      method,
      stack: stack ?? null,
    },
  });
}

export function dispatchValidationError({ message, issues = [], raw = null } = {}) {
  safeDispatch({
    error: {
      kind: "ZOD_VALIDATION_ERROR",
      message,
      issues,
      raw,
      status: null,
      url: null,
      method: null,
      data: null,
      stack: null,
    },
  });
}

export function dispatchAppError(message, { kind = "APP_ERROR" } = {}) {
  if (message == null || message === "") return;
  safeDispatch({
    error: {
      kind,
      message: String(message),
      status: null,
      url: null,
      method: null,
      data: null,
      issues: null,
      raw: null,
      stack: null,
    },
  });
}

